import 'navigator.sendbeacon';
import _ from 'underscore';
import Backbone from '@polleverywhere/backbone';
import env from '@polleverywhere/core/lib/env';
import { batchCallFunction, deepDefaults } from '@polleverywhere/core/lib/util';
import { Cannon } from '@polleverywhere/cutlass'; // TODO: Cutlass needs an internal event builder method for batch events.

var toCutlassEventFormat = function toCutlassEventFormat(name, props) {
  if (props === void 0) {
    props = {};
  }

  return {
    name: name,
    time: new Date(),
    properties: props,
    url: window.location.href,
    query_string: window.location.search
  };
};

var handleEvent = function handleEvent(self, events) {
  if (self.cannon) {
    self.cannon.accountId = self.app && self.app.user && self.app.user.get && self.app.user.get('account_id');
    self.cannon.userId = self.app && self.app.user && self.app.user.id;
    self.cannon.addEvents(_.flatten(events));
  }
};
/**
 * Listens to 'view:action' app events and sends them to cutlass.
 * An `event_type: 'view:action'` is added to the properties object when it is sent to cutlass.
 *
 * Calls within 1s are batched together and sent cutlass in bulk unless `immediate: true` is passed in as an option.
 *
 * @see https://github.com/polleverywhere/toolkit/blob/master/docs/app-events.md#viewaction App Event documentation
 *
 * @example Triggering an event
 *   @app.trigger "view:action", "event:name", { prop: "value", description: "Human description" }
 *
 * @example Triggering an immediate event that bypasses the 1s batching and sends it to Cutlass immediately
 *   @app.trigger "view:action", "event:name", { prop: "value", description: "Human description" }, { immediate: true }
 *
 */


var Cutlass =
/**
 * @param {Object} app Active PollEv.App object to listen for events on
 * @param {Object} cannonOpts Options for Cutlass::Cannon, see polleverywhere/cutlass.js:README.md
 * @param {Object} globalData Data that will always be appended to the event properties
 *                            This is useful when setting platform context when the UserAgent
 *                            can not be changed
 */
function Cutlass(app, cannonOpts, globalData) {
  var _this = this;

  if (cannonOpts === void 0) {
    cannonOpts = {};
  }

  if (globalData === void 0) {
    globalData = {};
  }

  this.app = app;
  this.cannonOpts = cannonOpts;
  this.globalData = globalData;

  _.extend(this, Backbone.Events);

  var baseUrl = env.get('cutlass_base_url');

  if (baseUrl) {
    this.cannon = new Cannon(baseUrl, this.cannonOpts);
  }

  this.batchHandlEvent = batchCallFunction(1000, _.partial(handleEvent, this));
  this.listenTo(this.app, 'view:action', function (name, data, opts) {
    if (data === void 0) {
      data = {};
    }

    if (opts === void 0) {
      opts = {};
    }

    data = deepDefaults(data, {
      event_type: 'view:action'
    }, _this.globalData);

    if (opts.immediate) {
      handleEvent(_this, [toCutlassEventFormat(name, data)]);
    } else {
      _this.batchHandlEvent(toCutlassEventFormat(name, data));
    }
  });
};

export { Cutlass as default };